export interface ApiGetClassificationDetailRequest {
    type: string;
    name: string;
}

interface ClassificationDetail {
    title: string;
    content: string;
}

export type ApiGetClassificationDetailResponse = ClassificationDetail[];

export const GetClassificationDetail = Symbol('GetClassificationDetail');

export interface GetClassificationDetail {
    getClassificationDetail(data: ApiGetClassificationDetailRequest): Promise<ApiGetClassificationDetailResponse>;
}
